import { render, staticRenderFns } from "./CoursePriceBlock.vue?vue&type=template&id=3557800e&"
import script from "./CoursePriceBlock.vue?vue&type=script&lang=ts&"
export * from "./CoursePriceBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports